import { useSelector } from "react-redux";

import { getValueSubtypeDefinitionSelector } from "../state/index.ts";

/** The app's subtype definitions, as the resolver a comparison over any signature needs. */
export const useGetValueSubtypeDefinition = () => useSelector(getValueSubtypeDefinitionSelector);
